
<script>

import { Pie, mixins } from 'vue-chartjs'

export default {
  name: 'Mortgage',
  extends: Pie,
  mixins: [mixins.reactiveProp],
  props: {
      data: Object
  },
  methods: {
		options(){
			return {
				responsive: true,
				maintainAspectRatio: true,
				tooltips: {
					enabled: false
				},
				legend: {
					onClick: function() { return; },
					position: 'bottom',
					labels: {
						boxWidth: 16,
						fontColor: '#888',
						fontSize: 13
					}
				},
			};
		}
	},
	// init render
	mounted() {
        this.renderChart(this.data, this.options());
        
	},
	// if any prop changes, render the chart again
	watch: {
		data() {
            this.renderChart(this.data, this.options());
		},


    },
}
</script>




